import { tokens } from '@JOTAJornalismo/jota-design-system'
import styled from 'styled-components'
import { MD_PX, SM_PX } from './post-page'
import { TABLET_SIZE } from '../components/lp/tributos/services.component'

const { colors, fonts, spaces } = tokens

const TABLET_SIZE_MIN = '550px'
const DESKTOP_SIZE_MIN = '1200px'

export const CoberturaCardRoot = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    justify-content: flex-start;
    border: 1px solid ${colors.transparent.jotaTGrayDark20};
    border-radius: 4px;

    & > Image {
        border-radius: 4px;
        display: none;
    }
`

export const CoberturaCardContent = styled.div`
    margin: ${spaces.jotaSpacing24} ${spaces.jotaSpacing16};
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`

export const CoberturaCardTitle = styled.h3`
    ${fonts.jotaHeading04()};
    color: ${colors.black.jotaBlack};
    margin: 0 0 ${spaces.jotaSpacing12} 0;
    font-size: 32px;
`

export const CoberturaCardDescription = styled.p`
    ${fonts.jotaBodyLarge()};
    color: ${colors.gray.jotaGrayDark};
    margin: 0 0 32px 0;
`

export const CoberturaCardCompanyRoot = styled.div`
    display: flex;
    flex-direction: column;
`

export const CoberturaCardSmall = styled.p`
    ${fonts.jotaOverlineXSmall()};
    color: ${colors.gray.jotaGrayDark};
    margin: 0 0 ${spaces.jotaSpacing8} 0;
`

export const CoberturaCardLogo = styled.div`
    display: flex;
    align-items: center;

    & > img {
        border-radius: 4px;
    }
`

export const CETitle = styled.h1`
    ${fonts.jotaHeading03()};
    color: ${colors.black.jotaBlack};
    padding-top: ${spaces.jotaSpacing12};
    margin: 0;
`

export const CEDisclaimer = styled.p`
    ${fonts.jotaBodyLarge()};
    color: ${colors.gray.jotaGrayDark};

    &:nth-child(2) {
        margin: 0 0 0 0;
    }

    margin: 0 0 0 0;
    padding: 0;

    & a {
        color: ${colors.gray.jotaGrayDarker};
        text-decoration: underline;
        font-weight: 600;
    }

    @media (max-width: ${SM_PX}) {
        margin-bottom: 0;
    }
`

export const CERoot = styled.div`
    margin: 0;
    width: 100%;
    margin-bottom: 44px;
`

export const CEHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid ${colors.transparent.jotaTGrayLight40};
    margin-bottom: ${spaces.jotaSpacing44};
    padding-top: 44px;

    & > div {
        padding-bottom: 8px;
    }

    @media (max-width: ${TABLET_SIZE_MIN}) {
        display: flex;
        flex-direction: column;
        margin-bottom: ${spaces.jotaSpacing44};
        border-bottom: none;

        & > div:nth-child(1) {
            border-bottom: 1px solid ${colors.transparent.jotaTGrayLight40};
            margin-bottom: ${spaces.jotaSpacing16};
        }
    }
`

export const CEContentSubtitle = styled.h2`
    margin: 0;
    ${fonts.jotaHeading04()};
    color: ${colors.black.jotaBlack};
`

export const CEContentGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: ${spaces.jotaSpacing44};

    @media (max-width: ${TABLET_SIZE_MIN}) {
        grid-template-columns: 1fr;
    }

    @media only screen and (min-width: ${TABLET_SIZE_MIN}) and (max-width: ${TABLET_SIZE}) {
        grid-template-columns: 1fr 1fr;
    }
`

export const CEUnicosContent = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin: ${spaces.jotaSpacing44} 0;
`

export const CEUnicosGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    gap: ${spaces.jotaSpacing44};
    margin-right: ${spaces.jotaSpacing44};

    @media (max-width: ${TABLET_SIZE_MIN}) {
        grid-template-columns: 1fr;
        width: 100%;
        margin-right: 0;
    }
`

export const CECPosts = styled.div`
    margin-top: 44px;
    padding-top: 44px;
    width: 100%;

    & > h1 {
        ${tokens.fonts.jotaHeading04};
        color: ${tokens.colors.black.jotaBlack};
        border-bottom: 1px solid ${tokens.colors.transparent.jotaTGrayLight40};
        margin-bottom: ${tokens.spaces.jotaSpacing24};
    }

    @media (min-width: ${TABLET_SIZE_MIN}) and (max-width: ${DESKTOP_SIZE_MIN}) {
        padding-top: 0;
    }

    @media (max-width: ${TABLET_SIZE_MIN}) {
        padding-top: 0;
    }
`

export const CECPostsHighlights = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 44px;
    margin-bottom: 44px;

    @media (max-width: ${TABLET_SIZE_MIN}) {
        grid-template-columns: 1fr;
        width: 100%;
        margin-right: 0;
    }

    @media (min-width: ${TABLET_SIZE_MIN}) and (max-width: ${DESKTOP_SIZE_MIN}) {
        grid-template-columns: repeat(2, 1fr);
        width: 100%;
        margin-right: 0;
        margin-bottom: 44px;
    }
`

export const CECPostsIndividual = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 44px;
    margin-bottom: 44px;

    @media (max-width: ${TABLET_SIZE_MIN}) {
        grid-template-columns: 1fr;
        width: 100%;
        margin-right: 0;
    }
`

export const MultipleLogosContainer = styled.div`
    margin-bottom: 80px;
`

export const MultipleLogos = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 60px;
    align-items: start;

    @media (max-width: ${MD_PX}) {
        grid-template-columns: repeat(1, 1fr);
    }
`
